module.exports = __webpack_public_path__ + "img/MapThumb_GreatLake.fd870804.webp";